import React from 'react'
import Icon from '@ant-design/icons';

export default (props) => {
  const {
    color, // цвет знака

    width,
    height,

    style: {
      width: style_width,
      height: style_height,
      color: style_color,
    } = {},
    ...rest
  } = props;

  const fill_color = color || style_color || '#A9C6E0';

  const w = width || style_width || 18;
  const h = height || style_height || 22;

  const SvgIcon = () => (
    <svg
      width={w}
      height={h}
      viewBox={`0 0 ${w} ${h}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9995 17.5C16.3206 20.1756 14.0412 21 11.3319 21H6.87884C3.62777 21 0.999512 18.1704 0.999512 14.6862V7.31376C0.999512 3.82964 3.634 1 6.87884 1H11.3319C14.0412 1 16.3206 1.81793 16.9995 4.5M4.00049 11H17.0005M17.0005 11L12.0005 6M17.0005 11L12.0005 16"
        stroke={fill_color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );

  return <Icon component={SvgIcon} {...rest} />;
}
